const SVG = ({ fill = 'currentColor', width = '20', height = '12', viewBox = '0 0 20 12' }) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 7.2h14V12l6-6-6-6v4.8H0v2.4z" />
  </svg>
)

export default SVG
